import { useMutation } from '@tanstack/react-query';
import { partnerLogin } from '../services/auth';

export const usePartnerLoginMutation = (options = {}) =>
  useMutation({
    mutationFn: async (credentials) => {
      const result = await partnerLogin(credentials);
      if (!result.success) {
        throw new Error(result.message || 'Login failed');
      }
      return result;
    },
    ...options,
  });
